// Material boundaries in the original 1024 × 1024 plates. These windows split
// the liquid and the enclosing artwork into complementary, independently drawn
// pieces. Follow the meniscus, glass edge and metal occluders, not a glow inset.
export const POTION_LIQUID = {
  lucidity: {
    color: '#65baff', deep: '#123d8a', hot: '#d8faff', cx: 500, cy: 710,
    d: 'M329 521Q487 469 663 520C690 571 775 637 775 726Q786 828 682 877Q512 943 349 873C237 827 218 741 242 661Q265 582 329 521Z',
    surface: 'M329 521Q490 582 663 520',
  },
  fixation: {
    color: '#ff5939', deep: '#79151b', hot: '#ffe8b2', cx: 509, cy: 651,
    d: 'M270 517Q507 471 741 517Q790 593 746 692L651 733Q578 801 508 827Q444 797 366 730L276 685Q230 590 270 517Z',
    surface: 'M271 519Q510 559 741 519',
  },
  avarice: {
    color: '#ffb934', deep: '#87420d', hot: '#fff0a7', cx: 510, cy: 699,
    d: 'M428 347L586 347Q592 412 640 466Q728 542 755 617Q748 671 684 646Q593 609 523 490L510 462L483 510Q418 608 339 648Q284 671 273 621Q291 550 367 474Q424 418 428 347Z M316 716Q361 729 404 710L441 759L502 790L559 764L613 709Q675 735 717 712Q752 779 699 841Q626 900 511 906Q398 903 320 853Q268 800 316 716Z M511 526Q445 620 451 676Q457 723 507 752Q571 712 571 662Q565 613 511 526Z',
  },
  curiosity: {
    color: '#ffbd48', deep: '#805018', hot: '#fff3b5', cx: 506, cy: 754,
    d: 'M264 677L365 666L375 729L501 807L635 735L655 668L760 677Q796 730 794 774Q763 848 666 893Q514 951 350 884Q250 839 230 764Q231 718 264 677Z M509 538Q465 580 429 632Q409 675 444 709L509 754Q552 731 585 697Q607 667 580 620Z',
  },
  euphoria: {
    color: '#ff739e', deep: '#9b2a55', hot: '#ffe7c2', cx: 511, cy: 710,
    d: 'M418 353Q509 376 595 352L637 402Q508 432 383 401Z M366 474Q511 491 661 474L771 652L684 865Q510 913 341 862L250 651Z M477 496Q512 474 546 499L558 528L583 534Q614 537 615 568L638 716L512 798L391 717L412 569Q408 539 443 536L465 524Z M468 576L548 565L580 589L586 690L512 761L438 693L453 600Z',
    // Outer body plus an even-odd cutout for the pendant, with its glass centre restored.
  },
  epiphany: {
    color: '#ba78ef', deep: '#573184', hot: '#fce1ff', cx: 510, cy: 685,
    d: 'M310 528Q510 463 712 529Q700 644 554 725L512 690L462 726Q325 645 310 528Z M251 566Q285 690 435 762L425 785L466 863L390 883Q248 802 227 706Q217 634 251 566Z M763 566Q796 631 791 702Q776 811 635 883L559 865L597 794L583 764Q729 686 763 566Z',
    surface: 'M310 528Q513 570 712 529',
  },
  yearning: {
    color: '#36dcb7', deep: '#085b59', hot: '#dbffe1', cx: 511, cy: 704,
    d: 'M347 539Q508 462 671 536C707 584 770 651 765 733Q763 864 521 880Q294 873 273 775C246 690 288 610 347 539Z',
    surface: 'M348 540Q407 585 533 611Q630 582 671 537',
  },
  rumination: {
    color: '#b7d34d', deep: '#455a20', hot: '#f5ffd1', cx: 515, cy: 683,
    d: 'M448 177L579 179L581 206L446 205Z M445 249L578 249Q583 332 634 374L702 440L594 450L518 396L441 450L323 444L389 390Q441 332 445 249Z M442 507L474 577L539 584L575 506L599 507Q691 699 582 850L445 853Q340 697 442 507Z M319 507L371 510Q283 688 380 839L331 832Q213 688 319 507Z M650 508L693 508Q808 687 685 836L640 843Q739 696 650 508Z',
  },
};
